// Bulk pricing tier logic - matches backend
export const BULK_TIERS = [
  { minQuantity: 10, maxQuantity: 24, discount: 10, label: '10–24 stems' },
  { minQuantity: 25, maxQuantity: 49, discount: 15, label: '25–49 stems' },
  { minQuantity: 50, maxQuantity: null, discount: 20, label: '50+ stems' },
];

// Derived from BULK_TIERS — single source of truth. No hardcoded thresholds.
export const getBulkDiscount = (quantity) => {
  for (let i = BULK_TIERS.length - 1; i >= 0; i -= 1) {
    if (quantity >= BULK_TIERS[i].minQuantity) return BULK_TIERS[i].discount;
  }
  return 0;
};

export const getDiscountedPrice = (pricePerStem, quantity) => {
  const discount = getBulkDiscount(quantity);
  return Math.round(pricePerStem * (1 - discount / 100));
};

export const getSavings = (pricePerStem, quantity) => {
  const discount = getBulkDiscount(quantity);
  return Math.round(pricePerStem * quantity * (discount / 100));
};
